module.exports = __webpack_public_path__ + "static/media/Home Page_website-19.fa84655e.png";